import { memo } from "react";
import { Badge } from "@/components/ui/badge";

const FAQ_ITEMS = [
  {
    q: "Mediastore est-il un spécialiste Apple à Niort ?",
    a: "Oui, Mediastore est spécialiste Apple à Niort. Notre équipe est composée de techniciens certifiés Apple capables d'intervenir sur iPhone, iPad, MacBook, iMac, Mac mini et Apple Watch.",
  },
  {
    q: "Combien coûte une réparation d'écran iPhone à Niort ?",
    a: "Le remplacement d'écran iPhone chez Mediastore Niort démarre à 59 € (iPhone 6/6s/7). Le tarif exact dépend du modèle. Le diagnostic est gratuit et le devis sans engagement.",
  },
  {
    q: "Quelle est la durée d'une réparation chez Mediastore Niort ?",
    a: "La plupart des réparations courantes (écran, batterie) sont effectuées en 30 à 60 minutes sur place. Pour les réparations plus complexes ou les ordinateurs, comptez quelques heures à 48 h.",
  },
  {
    q: "Réparez-vous toutes les marques de téléphones ?",
    a: "Oui. Mediastore Niort répare toutes les marques : Apple iPhone, Samsung Galaxy, Huawei, Xiaomi, OnePlus, Google Pixel, Honor, Oppo, ainsi que les tablettes iPad et Samsung Galaxy Tab.",
  },
  {
    q: "Réparez-vous les ordinateurs Mac et PC ?",
    a: "Oui, nous intervenons sur tous les ordinateurs Mac (MacBook Pro, MacBook Air, iMac, Mac mini) et PC portables/fixes toutes marques. Diagnostic gratuit à Niort.",
  },
  {
    q: "Proposez-vous une garantie sur les réparations ?",
    a: "Toutes nos réparations bénéficient d'une garantie 6 mois sur les pièces et la main d'œuvre.",
  },
  {
    q: "Où se trouve Mediastore à Niort ?",
    a: "Mediastore est situé au 104 Rue de la Gare, 79000 Niort. Téléphone : 05 49 05 74 90. Ouvert du lundi au vendredi 10h-18h et le samedi 10h-16h.",
  },
];

export const FAQSection = memo(() => (
  <section className="section-padding bg-white" data-testid="home-faq-section">
    <div className="container-custom max-w-4xl">
      <div className="text-center mb-12">
        <Badge className="bg-red-100 text-red-700 px-4 py-2 mb-4 hover:bg-red-100">FAQ</Badge>
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">Questions fréquentes</h2>
        <p className="text-lg text-slate-600">
          Toutes les réponses sur la réparation Apple, iPhone, Mac et ordinateur à Niort
        </p>
      </div>

      <ol className="space-y-4 list-none p-0">
        {FAQ_ITEMS.map((item, i) => (
          <li
            key={item.q}
            className="bg-slate-50 rounded-xl p-6 hover:bg-slate-100 transition-colors"
            data-testid={`faq-item-${i}`}
          >
            <h3 className="font-bold text-lg text-slate-900 mb-2 flex gap-3">
              <span className="text-red-600 flex-shrink-0">{i + 1}.</span>
              <span>{item.q}</span>
            </h3>
            <p className="text-slate-700 leading-relaxed pl-7">{item.a}</p>
          </li>
        ))}
      </ol>
    </div>
  </section>
));

FAQSection.displayName = "FAQSection";
